import { render, staticRenderFns } from "./ReportGuestOrderTableDesktop.vue?vue&type=template&id=b845e5d8&scoped=true"
import script from "./ReportGuestOrderTableDesktop.vue?vue&type=script&lang=js"
export * from "./ReportGuestOrderTableDesktop.vue?vue&type=script&lang=js"
import style0 from "./ReportGuestOrderTableDesktop.vue?vue&type=style&index=0&id=b845e5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b845e5d8",
  null
  
)

export default component.exports